import { useState, useEffect } from "react";
import MaterialExTable from "../../../components/tables/MaterialExTable";
import EditButton from "components/EditButton";
import { useSetRecoilState, useRecoilValue, useRecoilState } from "recoil";
import {
  officeShowState,
  officeViewData,
  officeFromOH,
  rowForEditOfficeSettings,
  officeEditState,
  DisableVendorField,
  DisableOfficeField,
  scorecardReportsDaily,
  leasedEquipmentsReports,
  linkedRow,
  openRelatedOfficeState,
  ofcFromVendor,
  prodCodeToOfficeId,
  ovsFromOffice,
  officeIdValue,
  showFromEmpTable,
  hideEmpPagerow,
} from "./atoms/atoms";
import { permissionsSelector } from "../../Login/selectors/permissionSelector";
import { useHistory, useLocation } from "react-router-dom";

import { isPrevPageState, mainSelectedTab } from "../atoms";
import { CarrierAgreementMgmtTabs } from "../carrierAgreementTabs";
import OfficeViews from "./views/OfficeViews";
import useGetOfficeForEdit from "./hooks/useGetOfficeForEdit";
import {
  daShowState,
  showFromNotifDA,
  showFromNotifViewDA,
} from "../DigitalAsset/atoms/atoms";
import {
  employeeShowState,
  FranchiseOfficeDetailsData,
} from "../Employees/Confie/atoms/atoms";
import { leFromOffice, leShowState } from "../LeasedEquipment/atom/atom";
import {
  businessLicenseOfficeId,
  busLicensesAddState,
  busLicensesEditState,
  busLicensesShowState,
} from "../BusinessLicensesAndPermits/atoms/atoms";
import { toast } from "../../../components/toastNotification";
import { vendorShowState } from "../Vendor/atoms/atoms";
import { securityAddButton } from "../Security/atoms/atoms";
import { isNewModuleState } from "../../CarrierAgreementMgmt/atoms";
import { OfficeTabs } from "../../OfficeTab/OfficeTabs";
import { VendorTabs } from "../../VendorTab/VendorTab";
import { ReportsTabs } from "../../ReportsTab/ReportsTab";
import { EmployeeTabs } from "../../EmployeeTab/EmployeeTab";
import { officeFromOHChart } from "../OfficeHierarchy/atoms/atoms";
import { accountAtom } from "modules/Login/atoms/AccountAtom";
import { applianceShowDetails } from "../OfficeAppliance/atom";
import { OFFICE_PERMISSIONS } from "./permission";

const OfficeSettingsTable = ({
  data = [],
  isLoading,
  viewFromOH = false,
  tableRef,
}) => {
  const user = useRecoilValue(accountAtom);
  const isFranchise = user.isFranchise;
  const [employeeId, setEmployeeId] = useState(0);
  let recordIdFromRecent = "";
  let location = useLocation();
  const history = useHistory();
  const setIsNewModuleFromLink = useSetRecoilState(isNewModuleState);
  if (location.state != null) {
    recordIdFromRecent = location.state;
    if (employeeId === 0) {
      if (recordIdFromRecent?.employeeId?.length > 0) {
        setEmployeeId(recordIdFromRecent?.employeeId);
      } else {
        const empredId = localStorage.getItem("empId");
        setEmployeeId(empredId);
      }
    }
  }
  const [, setIsHideEmpPagerow] = useRecoilState(hideEmpPagerow);
  const [isShow, setShowState] = useRecoilState(officeShowState);
  const [, setshowDA] = useRecoilState(daShowState);
  const [, setShowEmp] = useRecoilState(employeeShowState);
  const [, setShowLE] = useRecoilState(leShowState);
  const [showBLP, setShowBLP] = useRecoilState(busLicensesShowState);
  const [showVendor, setShowVendor] = useRecoilState(vendorShowState);
  const [showFromOH, setShowFromOH] = useRecoilState(officeFromOH);
  const [showFromOHChart, setShowFromOHChart] =
    useRecoilState(officeFromOHChart);
  const [showFromEmployee, setShowFromEmployee] = useState(false);
  const [showFromEmployeeTable, setShowFromEmployeeTable] =
    useRecoilState(showFromEmpTable);
  const [showFromRedirection, setShowFromRedirection] = useState(false);
  const [redirectionId, setRedirectionId] = useState("");
  const [, setViewFromVendor] = useRecoilState(ofcFromVendor);
  const [showFromEmpOfficeDetails, setShowFromEmpOfficeDetails] =
    useRecoilState(FranchiseOfficeDetailsData);
  const [showFromLE, setShowFromLE] = useState(false);
  const [showFromProdCode, setShowFromProdCode] = useState(false);
  const [showFromProdCodeModal, setShowFromProdCodeModal] = useState(false);
  const [prodCodeId, setProdCodeId] = useState("");
  const [prodCodeMcId, setprodCodeMcId] = useState("");
  const [, setShowFromBLP] = useState(false);
  const [showFromDigitalAsset, setShowFromDigitalAsset] =
    useRecoilState(showFromNotifViewDA);
  const [showFromDigitalAssetNotif, setShowFromDigitalAssetNotif] =
    useRecoilState(showFromNotifDA);
  const [showFromDigitalAssetTable, setShowFromDigitalAssetTable] =
    useRecoilState(openRelatedOfficeState);
  const [, setShowFromReports] = useState(false);
  const [showFromLeasedEquipmentReports, setShowFromLeasedEquipmentReports] =
    useRecoilState(leasedEquipmentsReports);
  const [showFromCamsReports, setShowFromCamsReports] = useState(false);
  const [
    showFromMappedtocdrcreportReports,
    setShowFromMappedtocdrcreportReports,
  ] = useState(false);
  const [showFromMappedToKeeperReports, setShowFromMappedToKeeperReports] =
    useState(false);
  const [showFromAllOpenOfficeReports, setShowFromAllOpenOfficeReports] =
    useState(false);
  const [showFromDarkOfficeReports, setShowFromDarkOfficeReports] =
    useState(false);
  const [showFromAllOfficeStatusReports, setShowFromAllOfficeStatusReports] =
    useState(false);
  const [showFromSalesforceAllReports, setShowFromSalesforceAllReports] =
    useState(false);
  const [showFromOfficeHourReports, setShowFromOfficeHourReports] =
    useState(false);
  const [showFromOfficeHierarchyReports, setShowFromOfficeHierarchyReports] =
    useState(false);
  const [
    showFromBillsOfficeHierarchyReports,
    setShowFromBillsOfficeHierarchyReports,
  ] = useState(false);
  const [showFromSalesOperationReports, setShowFromSalesOperationReports] =
    useState(false);
  const [showFromSPLCReports, setShowFromSPLCReports] = useState(false);
  const [showFromDAReports, setShowFromDAReports] = useState(false);
  const [showFromBLPReports, setShowFromBLPReports] = useState(false);
  const [showFromBLPWBUReports, setShowFromBLPWBUReports] = useState(false);
  const [showFromActiveEmployeeReports, setShowFromActiveEmployeeReports] =
    useState(false);
  const [showFromNoEmailEmployeeReports, setShowFromNoEmailEmployeeReports] =
    useState(false);
  const [showFromEmployeeClosedReport, setshowFromEmployeeClosedReport] =
    useState(false);
  const [showFromNoEmployeeIdReport, setshowFromNoEmployeeIdReport] =
    useState(false);
  const [
    showFromActiveSPLCEmployeeReports,
    setShowFromActiveSPLCEmployeeReports,
  ] = useState(false);
  const [showFromTerminatedSup, setshowFromTerminatedSup] = useState(false);
  const [showFromActiveTempReport, setShowFromActiveTempReport] =
    useState(false);
  const [showFromScorecardReportsDaily, setShowFromScorecardReportsDaily] =
    useRecoilState(scorecardReportsDaily);
  const [showFromScorecardReportsClosed, setShowFromScorecardReportsClosed] =
    useState(false);
  const [showFromScorecardReportsOpen, setShowFromScorecardReportsOpen] =
    useState(false);
  const [showFromOfficeApplianceTable, setShowFromOfficeApplianceTable] =
    useState(false);
  const [showFromOfficeApplianceView, setShowFromOfficeApplianceView] =
    useState(false);
  const [, setShowOfficeAppliance] = useRecoilState(applianceShowDetails);
  const setRowViewData = useSetRecoilState(officeViewData);
  const [, setRowToEdit] = useRecoilState(rowForEditOfficeSettings);
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const [, setEditState] = useRecoilState(officeEditState);
  const userPermissions = useRecoilValue(permissionsSelector);
  const editPermission =
    OFFICE_PERMISSIONS.permission_carrieragreemnentmgmt_office_edit;
  const confieEdit = userPermissions.includes(editPermission);
  const franEditPermission =
    OFFICE_PERMISSIONS.permission_office_franchiseoffice_edit;
  const franchiseEdit = userPermissions.includes(franEditPermission);

  const { mutate: getOfficeForEdit } = useGetOfficeForEdit();
  const [, setBusinessLicenseOfficeId] = useRecoilState(
    businessLicenseOfficeId
  );

  const [, setAddBLState] = useRecoilState(busLicensesAddState);
  const [, setEditBLState] = useRecoilState(busLicensesEditState);

  const [, setDisableOfficeField] = useRecoilState(DisableOfficeField);
  const [, setDisableVendorField] = useRecoilState(DisableVendorField);
  const [, setDisableAddButton] = useRecoilState(securityAddButton);
  const [, setShowFromLEOffice] = useRecoilState(leFromOffice);
  const [linkedRowData, setLinkedRowData] = useRecoilState(linkedRow);
  const [, setIsPrevPage] = useRecoilState(isPrevPageState);
  const [, setProdCodeToOfficeId] = useRecoilState(prodCodeToOfficeId);
  const [, setFromOffice] = useRecoilState(ovsFromOffice);
  const [showFromSecurity, setShowFromSecurity] = useState(false);
  const [isFromFranchiseDetails, setIsFromFranchiseDetails] = useState(false);
  const [, setGetOfficeId] = useRecoilState(officeIdValue);
  const [fromRecentProducerCode, setFromRecentProducerCode] = useState(false);
  const [previousPage, setPreviousPage] = useState(0);
  const [mexicoOffices, setMexicoOffices] = useState(false);
  const onClickOfficeName = (rowData) => {
    setIsHideEmpPagerow(true);
    setProdCodeToOfficeId(rowData.officeId);
    setGetOfficeId(rowData.officeId);

    if (viewFromOH) {
      setLinkedRowData(rowData);
      setShowFromOH(true);
      const url = "/officesettings/officesetting";
      history.push(url);
      const index = OfficeTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
    }
    setShowState(true);
    setRowViewData(rowData);
    setFromOffice(true);
  };

  useEffect(() => {
    //Redirection from Employee
    let actionFrom = new URLSearchParams(window.location.search).get(
      "actionFrom"
    );
    let officeCode = new URLSearchParams(window.location.search).get(
      "officeCode"
    );

    //Redirection from Producer Code
    const storedState = localStorage.getItem("officeRedirectState");
    let redirectData = recordIdFromRecent;

    if (storedState) {
      redirectData = JSON.parse(storedState);
    }

    if (
      recordIdFromRecent.action === "BusinessLicensePermit" &&
      data.length > 0
    ) {
      history.replace();
      const filteredData = data?.filter(
        (x) => x.officeId === recordIdFromRecent.officeId
      )[0];

      setRowViewData(filteredData);
      setShowState(true);
      setShowFromBLP(true);
    }
    if (recordIdFromRecent.action === "LeasedEquipment" && data.length > 0) {
      history.replace();
      const filteredData = data?.filter(
        (x) => x.officeId === recordIdFromRecent.officeId
      )[0];

      setRowViewData(filteredData);
      setShowState(true);
      setShowFromLE(true);
    }
    if (recordIdFromRecent.action === "Security" && data.length > 0) {
      history.replace();
      const filteredData = data?.filter(
        (x) => x.officeId === recordIdFromRecent.officeId
      )[0];

      setRowViewData(filteredData);
      setShowState(true);
      setShowFromSecurity(true);
    }
    if (
      recordIdFromRecent.action === "OfficeApplianceTable" &&
      data.length > 0
    ) {
      const filteredData = data?.find(
        (x) => x.officeId === recordIdFromRecent.officeId
      );

      setRowViewData(filteredData);
      setShowState(true);
      setShowFromOfficeApplianceTable(true);
    }
    if (
      recordIdFromRecent.action === "OfficeApplianceView" &&
      data.length > 0
    ) {
      const filteredData = data?.find(
        (x) => x.officeId === recordIdFromRecent.officeId
      );

      setRowViewData(filteredData);
      setShowState(true);
      setShowFromOfficeApplianceView(true);
    }
    if (recordIdFromRecent?.action === "VendorCancelToOffice") {
      setShowState(true);
      setRowViewData(recordIdFromRecent.officeId);
    }
    if (recordIdFromRecent?.action === "VendorCancelToOfficeVendor") {
      setShowState(true);
      setRowViewData(recordIdFromRecent.officeVendorData);
    }
    if (recordIdFromRecent?.action === "VendorCancelToOfficeSecurity") {
      setShowState(true);
      setRowViewData(recordIdFromRecent.officeSecurityData);
    }
    if (
      recordIdFromRecent.action === "ProdCodeToOfficeClose" &&
      data.length > 0
    ) {
      const filteredData = data?.filter(
        (x) => x.officeId === recordIdFromRecent.officeId
      )[0];
      setRowViewData(filteredData);
      setShowState(true);
    }
    if (redirectData.action === "ProducerAssociatedTo" && data.length > 0) {
      const filteredData = data?.filter(
        (x) => x.officeCode === redirectData.officeCode
      )[0];
      setRowViewData(filteredData);
      setprodCodeMcId(redirectData.masterCarrierId);
      setShowState(true);
      setShowFromProdCode(true);
      if (redirectData.fromRecent === true) {
        setFromRecentProducerCode(true);
      }
      localStorage.removeItem("officeRedirectState");
    }
    if (
      redirectData.action === "ProducerAssociatedToModal" &&
      data.length > 0
    ) {
      const filteredData = data?.filter(
        (x) => x.officeCode === redirectData.officeCode
      )[0];
      setRowViewData(filteredData);
      setprodCodeMcId(redirectData.masterCarrierId);
      setProdCodeId(redirectData.prodCodeId);
      setShowState(true);
      setShowFromProdCodeModal(true);
      localStorage.removeItem("officeRedirectState");
    }
    if (recordIdFromRecent.action === "Employee" && data.length > 0) {
      const filteredData = data?.filter(
        (x) => x.officeCode === recordIdFromRecent.officeCode
      )[0];
      setRowViewData(filteredData);
      setShowState(true);
      setShowFromEmployee(true);
    }
    if (recordIdFromRecent.action === "Employees" && data.length > 0) {
      const filteredData = data?.filter(
        (x) => x.officeId === Number(recordIdFromRecent.associatedOfficeId)
      )[0];

      setRowViewData(filteredData);
      setShowState(true);
      setShowFromEmployee(true);
    }
    if (recordIdFromRecent.action === "EmployeeTable" && data.length > 0) {
      if (recordIdFromRecent.fromRedirection === "No") {
        //  history.replace();
        const filteredData = data?.filter(
          (x) => x.officeCode === recordIdFromRecent.officeCode
        )[0];
        setShowFromEmployeeTable(true);
        setRowViewData(filteredData);
        setShowState(true);
      } else if (recordIdFromRecent.fromRedirection === "Yes") {
        //  history.replace();
        const filteredData = data?.filter(
          (x) => x.officeCode === recordIdFromRecent.officeCode
        )[0];

        setRowViewData(filteredData);
        setRedirectionId(recordIdFromRecent.empId);
        setShowState(true);
        setShowFromRedirection(true);
      }
    }
    if (
      recordIdFromRecent.action === "employeeFranchiseOfficeModal" &&
      data.length > 0
    ) {
      const filteredData = data?.filter(
        (x) => x.officeCode === recordIdFromRecent.officeCodes
      )[0];
      setRowViewData(filteredData);
      setShowState(true);
      setIsFromFranchiseDetails(true);
    }
    if (actionFrom === "Reports" && data.length > 0) {
      const filteredData = data?.filter((x) => x.officeCode === officeCode)[0];

      setRowViewData(filteredData);
      setShowState(true);
      setShowFromReports(true);
    }
    if (recordIdFromRecent.action === "DigitalAsset" && data.length > 0) {
      history.replace();
      const filteredData = data?.filter(
        (x) => x.officeCode === recordIdFromRecent.officeCode
      )[0];

      setRowViewData(filteredData);
      setShowState(true);
      setShowFromDigitalAsset(true);
    }

    if (actionFrom === "DigitalAssetTable" && data.length > 0) {
      let isPreviousPage = new URLSearchParams(window.location.search).get(
        "prevPage"
      );
      if (recordIdFromRecent.fromRecent === "No") {
        const filteredData = data?.filter(
          (x) => x.officeCode === officeCode
        )[0];
        setPreviousPage(isPreviousPage);
        setRowViewData(filteredData);
        setShowState(true);
        setShowFromDigitalAssetTable(true);
      } else if (recordIdFromRecent.fromRecent === "Yes") {
        const filteredData = data?.filter(
          (x) => x.officeCode === officeCode
        )[0];
        setRowViewData(filteredData);
        setShowState(true);
        setShowFromDigitalAssetNotif(true);
      }
    }

    if (recordIdFromRecent.action === "Vendor" && data.length > 0) {
      const filteredData = data?.filter(
        (x) => x.officeId === recordIdFromRecent.officeId
      )[0];

      setRowViewData(filteredData);
      setShowState(true);
      setShowVendor(true);
    }

    if (
      recordIdFromRecent.action === "OfficeHierarchyCancel" &&
      data.length > 0
    ) {
      const officeIdFromParent = localStorage.getItem("officeId");
      setShowFromEmployeeTable(recordIdFromRecent?.fromEmpTable);
      if (officeIdFromParent > 0) {
        const filteredData = data?.filter(
          (x) => x.officeId === parseInt(officeIdFromParent)
        )[0];
        setRowViewData(filteredData);
      } else {
        const filteredData = data?.filter(
          (x) => x.officeId === parseInt(recordIdFromRecent.officeId)
        )[0];
        setRowViewData(filteredData);
      }
      setShowState(true);
    }

    if (recordIdFromRecent.action === "AssociatedOffice" && data.length > 0) {
      const filteredData = data?.filter(
        (x) => x.officeId === recordIdFromRecent.officeId
      )[0];
      setRowViewData(filteredData);
      setShowState(true);
      setShowFromOHChart(true);
    }
    if (
      recordIdFromRecent.action === "LeasedEquipmentReports" &&
      data.length > 0
    ) {
      const filteredData = data?.filter(
        (x) => x.officeId === parseInt(recordIdFromRecent.officeId)
      )[0];
      setRowViewData(filteredData);
      setShowState(true);
      setShowFromLeasedEquipmentReports(true);
    }
    if (recordIdFromRecent.action === "csopcreport" && data.length > 0) {
      const filteredData = data?.filter(
        (x) => x.officeCode === recordIdFromRecent.officeCode
      )[0];

      setRowViewData(filteredData);
      setShowState(true);
      setShowFromCamsReports(true);
    }
    if (recordIdFromRecent.action === "mappedtocdrcreport" && data.length > 0) {
      const filteredData = data?.filter(
        (x) => x.officeCode === recordIdFromRecent.officeCode
      )[0];

      setRowViewData(filteredData);
      setShowState(true);
      setShowFromMappedtocdrcreportReports(true);
    }
    if (
      recordIdFromRecent.action === "mappedtokeeperreport" &&
      data.length > 0
    ) {
      const filteredData = data?.filter(
        (x) => x.officeCode === recordIdFromRecent.officeCode
      )[0];

      setRowViewData(filteredData);
      setShowState(true);
      setShowFromMappedToKeeperReports(true);
    }
    if (
      recordIdFromRecent.action === "AllOpenOfficeReports" &&
      data.length > 0
    ) {
      const filteredData = data?.filter(
        (x) => x.officeCode === recordIdFromRecent.officeCode
      )[0];

      setRowViewData(filteredData);
      setShowState(true);
      setShowFromAllOpenOfficeReports(true);
    }
    if (recordIdFromRecent.action === "DarkOfficeReports" && data.length > 0) {
      const filteredData = data?.filter(
        (x) => x.officeCode === recordIdFromRecent.officeCode
      )[0];
      setRowViewData(filteredData);
      setShowState(true);
      setShowFromDarkOfficeReports(true);
    }
    if (recordIdFromRecent.action === "OfficeHourReports" && data.length > 0) {
      const filteredData = data?.filter(
        (x) => x.officeCode === recordIdFromRecent.officeCode
      )[0];

      setRowViewData(filteredData);
      setShowState(true);
      setShowFromOfficeHourReports(true);
    }
    if (recordIdFromRecent.action === "AllOfficeStatus" && data.length > 0) {
      const filteredData = data?.filter(
        (x) => x.officeCode === recordIdFromRecent.officeCode
      )[0];

      setRowViewData(filteredData);
      setShowState(true);
      setShowFromAllOfficeStatusReports(true);
    }
    if (recordIdFromRecent.action === "SalesforceAll" && data.length > 0) {
      const filteredData = data?.filter(
        (x) => x.officeCode === recordIdFromRecent.officeCode
      )[0];

      setRowViewData(filteredData);
      setShowState(true);
      setShowFromSalesforceAllReports(true);
    }
    if (recordIdFromRecent.action === "OfficeHierarchy" && data.length > 0) {
      const filteredData = data?.filter(
        (x) => x.officeCode === recordIdFromRecent.officeCode
      )[0];

      setRowViewData(filteredData);
      setShowState(true);
      setShowFromOfficeHierarchyReports(true);
    }
    if (
      recordIdFromRecent.action === "BillsOfficeHierarchy" &&
      data.length > 0
    ) {
      const filteredData = data?.filter(
        (x) => x.officeCode === recordIdFromRecent.officeCode
      )[0];

      setRowViewData(filteredData);
      setShowState(true);
      setShowFromBillsOfficeHierarchyReports(true);
    }
    if (
      recordIdFromRecent.action === "SalesOperationReport" &&
      data.length > 0
    ) {
      const filteredData = data?.filter(
        (x) => x.officeCode === recordIdFromRecent.officeCode
      )[0];

      setRowViewData(filteredData);
      setShowState(true);
      setShowFromSalesOperationReports(true);
    }
    if (recordIdFromRecent.action === "SPLCOfficeReports" && data.length > 0) {
      const filteredData = data?.filter(
        (x) => x.officeCode === recordIdFromRecent.officeCode
      )[0];

      setRowViewData(filteredData);
      setShowState(true);
      setShowFromSPLCReports(true);
    }
    if (
      recordIdFromRecent.action === "DigitalAssetReports" &&
      data.length > 0
    ) {
      const filteredData = data?.filter((x) =>
        recordIdFromRecent?.officeCode !== ""
          ? x.officeCode === recordIdFromRecent?.officeCode
          : x.officeName === recordIdFromRecent?.officeName
      )[0];

      setRowViewData(filteredData);
      setShowState(true);
      setShowFromDAReports(true);
    }
    if (recordIdFromRecent.action === "BLPReports" && data.length > 0) {
      const filteredData = data?.filter(
        (x) => x.officeCode === recordIdFromRecent.officeCode
      )[0];

      setRowViewData(filteredData);
      setShowState(true);
      setShowFromBLPReports(true);
    }

    if (recordIdFromRecent.action === "BLPWBUReports" && data.length > 0) {
      const filteredData = data?.filter(
        (x) => x.officeCode === recordIdFromRecent.officeCode
      )[0];

      setRowViewData(filteredData);
      setShowState(true);
      setShowFromBLPWBUReports(true);
    }
    if (
      recordIdFromRecent.action === "ActiveEmployeeReports" &&
      data.length > 0
    ) {
      const filteredData = data?.filter(
        (x) => x.officeCode === recordIdFromRecent.officeCode
      )[0];

      setRowViewData(filteredData);
      setShowState(true);
      setShowFromActiveEmployeeReports(true);
    }
    if (
      recordIdFromRecent.action === "ActiveSPLCEmployeeReports" &&
      data.length > 0
    ) {
      const filteredData = data?.find(
        (x) => x.officeCode === recordIdFromRecent.officeCode
      );

      setRowViewData(filteredData);
      setShowState(true);
      setShowFromActiveSPLCEmployeeReports(true);
    }
    if (
      recordIdFromRecent.action === "EmployeeNoEmailReports" &&
      data.length > 0
    ) {
      const filteredData = data?.filter(
        (x) => x.officeCode === recordIdFromRecent.officeCode
      )[0];

      setRowViewData(filteredData);
      setShowState(true);
      setShowFromNoEmailEmployeeReports(true);
    }

    if (recordIdFromRecent.action === "ClosedLocation" && data.length > 0) {
      const filteredData = data?.filter(
        (x) => x.officeCode === recordIdFromRecent.officeCode
      )[0];

      setRowViewData(filteredData);
      setShowState(true);
      setshowFromEmployeeClosedReport(true);
    }
    if (recordIdFromRecent.action === "NoEmployeeId" && data.length > 0) {
      const filteredData = data?.filter(
        (x) => x.officeCode === recordIdFromRecent.officeCode
      )[0];

      setRowViewData(filteredData);
      setShowState(true);
      setshowFromNoEmployeeIdReport(true);
    }
    if (recordIdFromRecent.action === "WithTerminatedSup" && data.length > 0) {
      const filteredData = data?.filter(
        (x) => x.officeCode === recordIdFromRecent.officeCode
      )[0];

      setRowViewData(filteredData);
      setShowState(true);
      setshowFromTerminatedSup(true);
    }
    if (recordIdFromRecent.action === "ActiveTempReport" && data.length > 0) {
      const filteredData = data?.filter(
        (x) => x.officeCode === recordIdFromRecent.officeCode
      )[0];

      setRowViewData(filteredData);
      setShowState(true);
      setShowFromActiveTempReport(true);
    }
    if (
      recordIdFromRecent.action === "ScorecardReportDaily" &&
      data.length > 0
    ) {
      const filteredData = data?.filter(
        (x) => x.officeName === recordIdFromRecent.officeId
      )[0];
      setRowViewData(filteredData);
      setShowState(true);
      setShowFromScorecardReportsDaily(true);
    }
    if (
      recordIdFromRecent.action === "ScorecardReportClosed" &&
      data.length > 0
    ) {
      const filteredData = data?.filter(
        (x) => x.officeName === recordIdFromRecent.officeId
      )[0];
      setRowViewData(filteredData);
      setShowState(true);
      setShowFromScorecardReportsClosed(true);
    }
    if (
      recordIdFromRecent.action === "ScorecardReportOpen" &&
      data.length > 0
    ) {
      const filteredData = data?.filter(
        (x) => x.officeName === recordIdFromRecent.officeId
      )[0];
      setRowViewData(filteredData);
      setShowState(true);
      setShowFromScorecardReportsOpen(true);
    }
    if (recordIdFromRecent.action === "toOfficeView" && data.length > 0) {
      const filteredData = data?.filter(
        (x) => x.officeId === recordIdFromRecent.officeId
      )[0];
      setRowViewData(filteredData);
      setShowState(true);
    }
    if (recordIdFromRecent.action === "FromSplcHierarchy" && data?.length > 0) {
      const filteredData = data?.filter(
        (x) => x.officeId === recordIdFromRecent.officeId
      )[0];
      setRowViewData(filteredData);
      setShowState(true);
    }
    setIsNewModuleFromLink(true);
  }, [recordIdFromRecent, data]);
  useEffect(() => {
    if (viewFromOH) {
      setShowState(false);
    }
  }, []);

  const onClickCancelShow = (e) => {
    setIsHideEmpPagerow(false);
    localStorage.removeItem("officeId");
    localStorage.removeItem("empId");
    if (showFromOH) {
      setShowFromOH(false);
      const url = "/officesettings/officehierarchy";
      history.push({
        pathname: `/officesettings/officehierarchy?actionFrom=OHFromOfficeSettingCancel&officeHierarchyId=${linkedRowData?.officeHierarchyId}&officeId=${linkedRowData?.officeId}`,
      });
      let userTabs = [];
      [...OfficeTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0)
          userTabs.push({
            to: tabs.to,
          });
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setLinkedRowData(undefined);
    }
    if (showFromOHChart) {
      setShowFromOHChart(false);
      const url = "/officesettings/officehierarchy";
      history.push({
        pathname: recordIdFromRecent.path,
      });
      let userTabs = [];
      [...OfficeTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0)
          userTabs.push({
            to: tabs.to,
          });
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
    }
    if (showBLP) {
      const url = "/officesettings/buslicensesandpermits";
      history.push({
        pathname: url,
        state: {
          employeeId: recordIdFromRecent.employeeId,
          action: "OfficeCancel",
        },
      });
      let userTabs = [];
      [...OfficeTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowBLP(true);
    }
    if (showFromLE) {
      const url = "/officesettings/leasedequipment";
      history.push({
        pathname: url,
        state: {
          employeeId: recordIdFromRecent.employeeId,
          action: "OfficeCancel",
        },
      });
      let userTabs = [];
      [...OfficeTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowLE(true);
    }
    if (showFromSecurity) {
      const url = "/officesettings/security";
      history.push({
        pathname: url,
        state: {
          employeeId: recordIdFromRecent.employeeId,
          action: "OfficeCancel",
        },
      });
      let userTabs = [];
      [...OfficeTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
    }
    if (showFromOfficeApplianceTable) {
      const url = "/officesettings/officeappliance";
      history.push({
        pathname: url,
        state: {
          employeeId: recordIdFromRecent.employeeId,
          action: "OfficeCancel",
        },
      });
      const userTabs = [];

      for (const tab of OfficeTabs) {
        if (userPermissions.includes(tab.permission)) {
          userTabs.push({ to: tab.to });
        }
      }

      const index = userTabs.findIndex((t) => t.to === url);
      setSelectedIndex(index);
    }
    if (showFromOfficeApplianceView) {
      const url = "/officesettings/officeappliance";
      history.push({
        pathname: url,
        state: {
          officeApplianceId: recordIdFromRecent.officeApplianceId,
          action: "OfficeCancel",
        },
      });
      const userTabs = [];
      for (const tab of OfficeTabs) {
        if (userPermissions.includes(tab.permission)) {
          userTabs.push({ to: tab.to });
        }
      }

      const index = userTabs.findIndex((t) => t.to === url);
      setSelectedIndex(index);
      setShowOfficeAppliance(true);
    }
    if (showFromEmployee) {
      const url = "/employeetab/employee";
      history.push({
        pathname: url,
        state: {
          employeeId: employeeId ? employeeId : undefined,
          action: "OfficeCancel",
        },
      });
      window.location.reload();
      let userTabs = [];
      [...EmployeeTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      //setShowEmp(true);
    }
    if (showFromEmployeeTable) {
      const url = "/employeetab/employee";
      history.push({
        pathname: url,
        state: {
          employeeId: employeeId,
          action: "closeFromRedirection",
          recordId: employeeId?.toString(),
        },
      });
      window.location.reload();
      let userTabs = [];
      [...EmployeeTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      //setShowEmp(true);
    }
    if (showFromRedirection) {
      const url = "/employeetab/employee";
      history.push({
        pathname: url,
        state: {
          employeeId: employeeId,
          moduleName: "Employee",
          recordId: redirectionId,
        },
      });
      window.location.reload();
      let userTabs = [];
      [...EmployeeTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
    }
    if (showFromEmpOfficeDetails) {
      const url = "/employeetab/employee";
      history.push({
        pathname: "/employeetab/employee",
        state: {
          employeeId: employeeId,
          action: "OfficeCancel",
          recordId: employeeId?.toString(),
        },
      });
      window.location.reload();
      let userTabs = [];
      [...OfficeTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromEmpOfficeDetails(true);
    }
    if (isFromFranchiseDetails) {
      const url = "/employeetab/employee";
      history.push({
        pathname: "/employeetab/employee",
        state: {
          employeeId: employeeId,
          action: "OfficeCancel",
        },
      });
      window.location.reload();
      let userTabs = [];
      [...OfficeTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowEmp(true);
      setShowFromEmpOfficeDetails(true);
    }
    if (showFromDigitalAsset) {
      const daId = localStorage.getItem("DigitalAssetsId");
      const url = "/officesettings/digitalasset";
      history.push({
        pathname: url,
        state: {
          employeeId: recordIdFromRecent.employeeId,
          action: "OfficeCancel",
          daRecordId: daId,
        },
      });
      const index = OfficeTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setshowDA(true);
      setShowFromDigitalAsset(false);
    }
    if (showFromDigitalAssetNotif && !showFromDigitalAsset) {
      const daId = localStorage.getItem("DigitalAssetsId");
      const url = "/officesettings/digitalasset";
      history.push({
        pathname: url,
        state: {
          action: "closeFromRedirection",
          daRecordId: daId,
        },
      });
      let userTabs = [];
      [...OfficeTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setshowDA(false);
      setShowFromDigitalAssetNotif(false);
      localStorage.removeItem("DigitalAssetsId");
    }

    if (showFromDigitalAssetTable) {
      const url = "/officesettings/digitalasset";
      history.push({
        pathname: "/officesettings/digitalasset?prevPage=" + previousPage,
      });
      let userTabs = [];
      [...OfficeTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setshowDA(false);
      setShowFromDigitalAssetTable(false);
      setIsPrevPage(true);
    }

    if (showVendor) {
      const url = "/vendortab/vendor";
      history.push({
        pathname: url,
        state: {
          action: "RedirectToVendor",
        },
      });

      window.location.reload();

      let userTabs = [];
      [...VendorTabs].forEach((tabs) => {
        let temp = [...userPermissions].filter(
          (user) => user === tabs.permission
        );
        if (temp.length > 0) userTabs.push(tabs);
      });
      const index = userTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setViewFromVendor(true);
    }
    if (showFromCamsReports) {
      const url = "/reportstab/producercode/csopc_reports";
      history.push({
        pathname: "/reportstab/producercode/csopc_reports",
        state: {
          officeCode: recordIdFromRecent.officeCode,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromMappedtocdrcreportReports) {
      const url = "/reportstab/producercode/mappedtocdrc_reports";
      history.push({
        pathname: "/reportstab/producercode/mappedtocdrc_reports",
        state: {
          officeCode: recordIdFromRecent.officeCode,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromMappedToKeeperReports) {
      const url = "/reportstab/producercode/keeper_reports";
      history.push({
        pathname: url,
        state: {
          officeCode: recordIdFromRecent.officeCode,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromAllOpenOfficeReports) {
      const url = "/reportstab/office/allopen_offices_reports";

      history.push({
        pathname: "/reportstab/office/allopen_offices_reports",
        state: {
          officeCode: recordIdFromRecent.officeCode,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = OfficeTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromDarkOfficeReports) {
      const url = "/reportstab/office/darkoffices";
      history.push({
        pathname: "/reportstab/office/darkoffices",
        state: {
          officeCode: recordIdFromRecent.officeCode,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromAllOfficeStatusReports) {
      const url = "/reportstab/office/allofficesstatus";
      history.push({
        pathname: "/reportstab/office/allofficesstatus",
        state: {
          officeCode: recordIdFromRecent.officeCode,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromSalesforceAllReports) {
      const url = "/reportstab/office/salesforceOfficesReport";
      history.push({
        pathname: "/reportstab/office/salesforceOfficesReport",
        state: {
          officeCode: recordIdFromRecent.officeCode,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromOfficeHourReports) {
      const url = "/reportstab/office/officeHoursReport";
      history.push({
        pathname: "/reportstab/office/officeHoursReport",
        state: {
          officeCode: recordIdFromRecent.officeCode,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromOfficeHierarchyReports) {
      const url = "/reportstab/office/officeHierarchyReport";
      history.push({
        pathname: "/reportstab/office/officeHierarchyReport",
        state: {
          officeCode: recordIdFromRecent.officeCode,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromBillsOfficeHierarchyReports) {
      const url = "/reportstab/office/billsOfficeHierarchyReport";
      history.push({
        pathname: "/reportstab/office/billsOfficeHierarchyReport",
        state: {
          officeCode: recordIdFromRecent.officeCode,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromSalesOperationReports) {
      const url = "/reportstab/office/salesoperationsReport";
      history.push({
        pathname: "/reportstab/office/salesoperationsReport",
        state: {
          officeCode: recordIdFromRecent.officeCode,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromSPLCReports) {
      const url = "/reportstab/office/splcOfficesReport";
      history.push({
        pathname: "/reportstab/office/splcOfficesReport",
        state: {
          officeCode: recordIdFromRecent.officeCode,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromDAReports) {
      const url = "/reportstab/digital_assets";
      history.push({
        pathname: "/reportstab/digital_assets",
        state: {
          officeCode: recordIdFromRecent.officeCode,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromLeasedEquipmentReports) {
      const url = "/reportstab/leased_equipment";
      history.push({
        pathname: "/reportstab/leased_equipment",
        state: {
          officeCode: recordIdFromRecent.officeCode,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromBLPReports) {
      const url =
        "/reportstab/business_license/business_licenses_permits_allconfie_report";
      history.push({
        pathname:
          "/reportstab/business_license/business_licenses_permits_allconfie_report",
        state: {
          officeCode: recordIdFromRecent.officeCode,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromBLPWBUReports) {
      const url =
        "/reportstab/business_license/business_licenses_permits_westBU_report";
      history.push({
        pathname:
          "/reportstab/business_license/business_licenses_permits_westBU_report",
        state: {
          officeCode: recordIdFromRecent.officeCode,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromActiveEmployeeReports) {
      const url = "/reportstab/employees/employees_activeemployees_reports";
      history.push({
        pathname: "/reportstab/employees/employees_activeemployees_reports",
        state: {
          officeCode: recordIdFromRecent.officeCode,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromActiveSPLCEmployeeReports) {
      const url = "/reportstab/employees/employees_activesplcemployees_reports";
      history.push({
        pathname: url,
        state: {
          officeCode: recordIdFromRecent.officeCode,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
    }
    if (showFromNoEmailEmployeeReports) {
      const url = "/reportstab/employees/employees_no_emailaddress_reports";
      history.push({
        pathname: "/reportstab/employees/employees_no_emailaddress_reports",
        state: {
          officeCode: recordIdFromRecent.officeCode,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromEmployeeClosedReport) {
      const url = "/reportstab/employees/employees_closedlocations_reports";
      history.push({
        pathname: "/reportstab/employees/employees_closedlocations_reports",
        state: {
          officeCode: recordIdFromRecent.officeCode,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromNoEmployeeIdReport) {
      const url = "/reportstab/employees/employees_noemployeeid_reports";
      history.push({
        pathname: "/reportstab/employees/employees_noemployeeid_reports",
        state: {
          officeCode: recordIdFromRecent.officeCode,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromTerminatedSup) {
      const url =
        "/reportstab/employees/employees_withterminatedsupervisors_reports";
      history.push({
        pathname:
          "/reportstab/employees/employees_withterminatedsupervisors_reports",
        state: {
          officeCode: recordIdFromRecent.officeCode,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromActiveTempReport) {
      const url = "/reportstab/employees/employees_activetemp_reports";
      history.push({
        pathname: "/reportstab/employees/employees_activetemp_reports",
        state: {
          officeCode: recordIdFromRecent.officeCode,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromScorecardReportsDaily) {
      const url = "/reportstab/scorecard/scorecard_daily_reports";
      history.push({
        pathname: "/reportstab/scorecard/scorecard_daily_reports",
        state: {
          officeCode: recordIdFromRecent.officeCode,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromScorecardReportsClosed) {
      const url = "/reportstab/scorecard/scorecard_closed_reports";
      history.push({
        pathname: "/reportstab/scorecard/scorecard_closed_reports",
        state: {
          officeCode: recordIdFromRecent.officeCode,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromScorecardReportsOpen) {
      const url = "/reportstab/scorecard/scorecard_open_reports";
      history.push({
        pathname: "/reportstab/scorecard/scorecard_open_reports",
        state: {
          officeCode: recordIdFromRecent.officeCode,
          action: "OfficeCancel",
          reportsKey: "reportsKey",
        },
      });
      window.location.reload();
      const index = ReportsTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
      setShowFromReports(true);
    }
    if (showFromProdCode) {
      const url = "/officesettings/officesetting";
      history.push({
        pathname: "/carrieragreementmgmt/producercodeconfig/table",
        state: {
          masterCarrierId: prodCodeMcId,
          action: "CloseOfficeToProd",
          fromRecent: fromRecentProducerCode,
        },
      });
      window.location.reload();
      const index = CarrierAgreementMgmtTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
    }
    if (showFromProdCodeModal) {
      const url = "/officesettings/officesetting";
      history.push({
        pathname: "/carrieragreementmgmt/producercodeconfig/table",
        state: {
          masterCarrierId: prodCodeMcId,
          producerCodeId: prodCodeId,
          action: "CloseOfficeToProdModal",
        },
      });
      window.location.reload();
      const index = CarrierAgreementMgmtTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
    }
    setShowState(false);
    setRowViewData([]);
    setBusinessLicenseOfficeId(null);
    setShowFromLEOffice(false);
    setAddBLState(false);
    setEditBLState(false);
    setDisableOfficeField(false);
    setDisableVendorField(false);
    setDisableAddButton(false);
  };

  const to24HrTime = (time) => {
    if (time && time !== "Closed") {
      let [hr, min, ap] = time.toLowerCase().match(/\d+|[a-z]+/g) || [];

      return `${
        ap === "am"
          ? hr > 11
            ? "00:" + min
            : hr + ":" + min
          : (hr % 12) + 12 + ":" + min
      }`;
    } else {
      return "";
    }
  };
  const handleEdit = (rowDetails) => {
    if (viewFromOH) {
      getOfficeForEdit(rowDetails.officeId, {
        onSuccess: (officeResult) => {
          setShowFromOH(true);
          const url = "/carrieragreementmgmt/officesetting";
          history.push("officesetting");
          const index = CarrierAgreementMgmtTabs.findIndex((c) => c.to === url);
          setSelectedIndex(index);
          fixOfficeDetailForEdit(officeResult);
          setEditState(true);
        },
        onError: () => {
          toast.fire(
            "Server Issue",
            "Cannot retrieve data, please check network",
            "error"
          );
        },
      });
    } else if (!isShow) {
      getOfficeForEdit(rowDetails.officeId, {
        onSuccess: (officeResult) => {
          fixOfficeDetailForEdit(officeResult);
          setEditState(true);
        },
      });
    } else {
      fixOfficeDetailForEdit(rowDetails);
      setEditState(true);
    }
  };

  const fixOfficeDetailForEdit = (officeData) => {
    const imageSectionLists =
      officeData?.fileImageLists === null
        ? []
        : officeData?.fileImageLists?.map((file, index) => {
            return {
              ...file,
              parentRow: index > 0 ? false : true,
              tableName: "fileImageLists",
            };
          });
    setRowToEdit({
      ...officeData,
      fileImageLists: [...imageSectionLists],
      fileNames: officeData?.fileImageLists,
      originalOpenedDate: officeData.originalOpenedDate
        ? officeData.originalOpenedDate.slice(0, 10)
        : null,
      officeOpenedDate: officeData.officeOpenedDate
        ? officeData.officeOpenedDate.slice(0, 10)
        : null,
      acquisitionDate: officeData.acquisitionDate
        ? officeData.acquisitionDate.slice(0, 10)
        : null,
      relocationDate: officeData.relocationDate
        ? officeData.relocationDate.slice(0, 10)
        : null,
      officeClosedDate: officeData.officeClosedDate
        ? officeData.officeClosedDate.slice(0, 10)
        : null,
      officeHierarchyEffectiveDate: officeData.officeHierarchyEffectiveDate
        ? officeData.officeHierarchyEffectiveDate.slice(0, 10)
        : null,
      darkReasonEffectiveDate: officeData.darkReasonEffectiveDate
        ? officeData.darkReasonEffectiveDate.slice(0, 10)
        : null,
      reOpenDate: officeData.reOpenDate
        ? officeData.reOpenDate.slice(0, 10)
        : null,
      shippingLastVerified: officeData.shippingLastVerified
        ? new Date(officeData.shippingLastVerified).toLocaleString()
        : null,
      mondayStartTime:
        officeData.mondayStoreHours !== "Closed"
          ? to24HrTime(officeData.mondayStoreHours?.split("-")[0])
          : null,
      mondayEndTime:
        officeData.mondayStoreHours !== "Closed"
          ? to24HrTime(officeData.mondayStoreHours?.split("-")[1])
          : null,
      tuesdayStartTime:
        officeData.tuesdayStoreHours !== "Closed"
          ? to24HrTime(officeData.tuesdayStoreHours?.split("-")[0])
          : null,
      tuesdayEndTime:
        officeData.tuesdayStoreHours !== "Closed"
          ? to24HrTime(officeData.tuesdayStoreHours?.split("-")[1])
          : null,
      wedsStartTime:
        officeData.wednesdayStoreHours !== "Closed"
          ? to24HrTime(officeData.wednesdayStoreHours?.split("-")[0])
          : null,
      wedsEndTime:
        officeData.wednesdayStoreHours !== "Closed"
          ? to24HrTime(officeData.wednesdayStoreHours?.split("-")[1])
          : null,
      thursStartTime:
        officeData.thursdayStoreHours !== "Closed"
          ? to24HrTime(officeData.thursdayStoreHours?.split("-")[0])
          : null,
      thursEndTime:
        officeData.thursdayStoreHours !== "Closed"
          ? to24HrTime(officeData.thursdayStoreHours?.split("-")[1])
          : null,
      fridayStartTime:
        officeData.fridayStoreHours !== "Closed"
          ? to24HrTime(officeData.fridayStoreHours?.split("-")[0])
          : null,
      fridayEndTime:
        officeData.fridayStoreHours !== "Closed"
          ? to24HrTime(officeData.fridayStoreHours?.split("-")[1])
          : null,
      satStartTime:
        officeData.saturdayStoreHours !== "Closed"
          ? to24HrTime(officeData.saturdayStoreHours?.split("-")[0])
          : null,
      satEndTime:
        officeData.saturdayStoreHours !== "Closed"
          ? to24HrTime(officeData.saturdayStoreHours?.split("-")[1])
          : null,
      sunStartTime:
        officeData.sundayStoreHours !== "Closed"
          ? to24HrTime(officeData.sundayStoreHours?.split("-")[0])
          : null,
      sunEndTime:
        officeData.sundayStoreHours !== "Closed"
          ? to24HrTime(officeData.sundayStoreHours?.split("-")[1])
          : null,
    });
  };

  const DisableEdit = (rowData) => {
    const isFranchiseType = rowData?.officeType
      ?.toLowerCase()
      ?.includes("franchise");

    if (franchiseEdit && confieEdit) return false;

    if (franchiseEdit && !isFranchiseType) return true;
    if (confieEdit && isFranchiseType) return true;

    return false;
  };

  const materialColumns = [
    {
      title: "Office Information",
      field: "officeName",
      render: (rowdata) => {
        return !user.isFranchise &&
          !user.isNonFranchise &&
          user.isMexico &&
          rowdata.country === "United States" &&
          viewFromOH ? (
          <>
            {setMexicoOffices(true)}
            <span className="font-bold">{rowdata.officeName}</span>
            <br></br>
            <div className="space-y-0">
              {rowdata.address} {rowdata.addressLine2} {rowdata.city},{" "}
              {rowdata.stateCode} {rowdata.zipCode} {rowdata.country}
            </div>
          </>
        ) : (
          <div
            className="cursor-pointer"
            onClick={() => onClickOfficeName(rowdata)}
          >
            <span className="blueAndBold underline ">{rowdata.officeName}</span>
            <br></br>
            <div className="space-y-0">
              {rowdata.address} {rowdata.addressLine2} {rowdata.city},{" "}
              {rowdata.stateCode} {rowdata.zipCode} {rowdata.country}
            </div>
          </div>
        );
      },
      cellStyle: {
        textAlign: "left",
        width: "35%",
        fontSize: "12px",
      },
    },
    {
      title: "Full Address",
      field: "fullAddress",
      hidden: true,
      searchable: true,
    },
    {
      title: "Address",
      field: "address",
      hidden: true,
      searchable: true,
    },
    { title: "City", field: "city", hidden: true, searchable: true },
    { title: "State Code", field: "stateCode", hidden: true, searchable: true },
    { title: "Zip Code", field: "zipCode", hidden: true, searchable: true },
    { title: "Country", field: "country", hidden: true, searchable: true },
    { title: "Office Code", field: "officeCode" },
    {
      title: "Business Operations",
      field: "businessOperation",
    },
    { title: "Office Type", field: "officeType" },
    { title: "Office Status", field: "officeStatus" },
    { title: "Phone", field: "phone" },
    {
      title: "Action",
      align: "center",
      hidden:
        !user.isFranchise &&
        !user.isNonFranchise &&
        user.isMexico &&
        mexicoOffices &&
        viewFromOH,
      render: (rowData) => {
        return confieEdit || franchiseEdit ? (
          <div className=" flex justify-center mr-4">
            <EditButton
              className=""
              buttonText="Edit"
              onClick={() => {
                handleEdit(rowData);
              }}
              disabled={DisableEdit(rowData)}
            />
          </div>
        ) : (
          ""
        );
      },
    },
  ];
  return (
    <>
      <div className="w-full">
        {!isShow ? (
          <MaterialExTable
            columns={materialColumns}
            data={data?.map((data) => ({ ...data }))}
            isLoading={isLoading}
            style={{
              backgroundColor: "fff",
              color: "#000",
            }}
            tableRef={tableRef}
            search={true}
            toolbar={true}
          />
        ) : (
          ""
        )}
      </div>
      {isShow && (
        <OfficeViews
          onClickCancelShow={onClickCancelShow}
          handleEdit={handleEdit}
          confieEdit={confieEdit}
          franchiseEdit={franchiseEdit}
        />
      )}
    </>
  );
};

export default OfficeSettingsTable;
